






























































































































import { Component, Vue } from 'vue-property-decorator'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import API from '@core/services/API'
import { IDateService } from '@master/services/IDateService'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppDialog from '@core/components/AppDialog.vue'
import { inject } from 'inversify-props'
import { isNull, isUndefined } from 'lodash/fp'
import type { FileDto } from './model/FileDto'

@Component({
  components: {
    AppDatatable,
    AppDialog
  }
})
export default class Resources extends Vue {
    @inject()
    private $api: API

    @inject()
    private dateService: IDateService

    @inject()
    private sharedVariable: SharedVariable

    uiService: UIService

    private userOid = this.$store.getters.currentUser._oid
    private fileList = {
      files: [],
      folders: []
    }

    private isModalNewFolderVisible = false
    private currentPath = ''
    private newFolder: FileDto = {
      fileOid: '',
      userOid: '',
      fileName: '',
      createdAt: undefined,
      filePath: '',
      fileSize: 0
    }

    get uploadActionUrl () {
      return '/live/api/resources/createFile'
    }

    get userIsAdmin () {
      return this.$store.getters.currentUser.isSuperUser
    }

    get folders () {
      return this.filteredFilesFolders(this.fileList.folders, 'folders')
    }

    get files () {
      return this.filteredFilesFolders(this.fileList.files, 'files')
    }

    get paths () {
      // get the current path in array, and remove the empty value
      return this.currentPath.split('/').filter(e => e)
    }

    filteredFilesFolders (_data, type) {
      return _data.filter(data => {
        // get the file path in array, and remove the empty value
        const filteredPath = data.fileName.split('/').filter(e => e)
        if (type === 'folders') data.folderName = filteredPath[this.paths.length]
        if (type === 'files') data.tempFileName = filteredPath[this.paths.length]

        // filter the path to show only the direct children folder
        return this.paths.length + 1 === filteredPath.length
      }) || []
    }

    copyFileUrl (file) {
      const fileUrl = `https://pfr.awfa.com.sg/live/api/resources/file/${file.fileOid}`
      navigator.clipboard.writeText(fileUrl)
      this.uiService.alert.show({
        type: 'info',
        message: 'Download link copied to clipboard'
      })
    }

    handleFAQSubmit () {
      const form: any = this.$refs.faqUpload
      form.submit()
    }

    async uploadFile (params) {
      const formData = new FormData()
      formData.append('fileName', this.currentPath + params.file.name)
      formData.append('file', params.file)

      await this.$api.resources.createFile(formData)
      await this.fetchAllFilesFolders()
    }

    onUploadSuccess (response, file) {
      this.uiService.alert.show({
        type: 'success',
        message: `${file.name} successfully uploaded!`
      })
      const form: any = this.$refs.uploadList
      form.clearFiles()
      this.fetchAllFilesFolders()
    }

    onUploadError () {
      this.uiService.alert.show({
        type: 'error',
        message: 'Failed to upload file!'
      })
    }

    formatFileSize (bytes = 0, si = true, dp = 0) {
      const thresh = si ? 1000 : 1024

      if (isUndefined(bytes) || isNull(bytes)) return '0B'
      if (Math.abs(bytes) < thresh) {
        return bytes + ' B'
      }

      const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
      let u = -1
      const r = 10 ** dp

      do {
        bytes /= thresh
        ++u
      } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

      return bytes.toFixed(dp) + '' + units[u]
    }

    handleNewCommand (command) {
      // https://element.eleme.io/#/en-US/component/dropdown
      if (command === 'NewFolder') {
        this.isModalNewFolderVisible = true
        this.newFolder.fileName = ''
      }
    }

    redirect (fileName: string) {
      this.currentPath = fileName
      this.fetchAllFilesFolders()
    }

    async createNewFolder () {
      this.newFolder.createdAt = Date.now()
      await this.$api.resources.createFolder({ folderName: `${this.currentPath}${this.newFolder.fileName}/` })

      this.isModalNewFolderVisible = false
      this.uiService.alert.show({
        type: 'success',
        message: `${this.newFolder.fileName} successfully created!`
      })
      this.fetchAllFilesFolders()
    }

    async downloadFile (file) {
      window.open(`/live/api/resources/file/${file.fileOid}`, '_blank')
    }

    async deleteFile (file) {
      const isConfirm = await this.uiService.confirm.show({
        type: 'warning',
        message: 'Are you sure you want to delete this file? This process is irreversible.'
      })
      if (!isConfirm) return
      await this.$api.resources.deleteFiles({ fileName: file.fileName })
      await this.uiService.alert.show({
        type: 'success',
        message: `${file.fileName} successfully deleted!`
      })
      await this.fetchAllFilesFolders()
    }

    async fetchAllFilesFolders () {
      const data = await this.$api.resources.getAllFilesFolders({ filePath: this.currentPath })
      this.fileList = data
      this.$emit('update', this.fileList)
    }

    async mounted () {
      this.uiService = this.sharedVariable.uiService

      await this.fetchAllFilesFolders()
    }
}
